import React from "react"

import RatingOptionPill from "../option-pill"

export default function FieldRating_DropdownValueNotEmpty(props:any) {
    return (
        <React.Fragment>
            <div className={Classes("ui5-field-form-editable dropdown-form h-36", props.className)} onClick={props.onClick}>
                <RatingOptionPill scale={props.scale} option={props.option}/>
            </div>
            {props.children}
        </React.Fragment>
    )
}